/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Cta_LedeInputs */

const en_services_cta_lede = /** @type {(inputs: Services_Cta_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tell us where the time goes, where revenue slips and what you’d like a system to take on.`)
};

const lv_services_cta_lede = /** @type {(inputs: Services_Cta_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pastāstiet, kur aiziet laiks, kur paslīd ienākumi un ko gribētu uzticēt sistēmai.`)
};

/**
* | output |
* | --- |
* | "Tell us where the time goes, where revenue slips and what you’d like a system to take on." |
*
* @param {Services_Cta_LedeInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_cta_lede = /** @type {((inputs?: Services_Cta_LedeInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Cta_LedeInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_cta_lede(inputs)
	return en_services_cta_lede(inputs)
});